import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

interface WorkflowsNames {
	errorMessage: any;
	message: any;
	id: number;
	name: string;
}

@Injectable()
export class WorkflowDataProvider {
	private ALL_WORKFLOWS_URL = '/protected/rest/workflows';
	private JOB_WORKFLOW_URL = '/protected/rest/workflow';

	private defaultWorkflow: any = {
		name: 'Default',
		id: null
	};

	workflowNames: Array<WorkflowsNames> = [];

	constructor(private http: HttpClient) {}

	getWorkflowNames() {
		return this.getWorkflowNamesFromServer().map((data: any) => {
			if (data !== undefined && data !== null && data.workflowNames) {
				this.setWorkflowNamesInStorage(data.workflowNames);
				return JSON.parse(JSON.stringify(this.workflowNames));
			}
			return data;
		});
	}

	saveTask(task) {
		const url = `${this.JOB_WORKFLOW_URL}/task/`;
		return this.http.post(url, task).map((data: any) => {
			data.taskToAnimate = task.number;
			return data;
		});
	}

	deleteTask(id) {
		const url = `${this.JOB_WORKFLOW_URL}/task/${id}`;
		return this.http.delete(url);
	}

	getTaskTemplates(id) {
		const url = `${this.ALL_WORKFLOWS_URL}/get`;
		const params = new HttpParams().set('id', id);
		return this.http.get(url, { params });
	}

	saveWorkflow(workflow) {
		const url = `${this.ALL_WORKFLOWS_URL}/save`;
		return this.http.post(url, workflow);
	}

	getWorkflow(id) {
		const url = `/protected/rest/jobs/workflow/?jobId=${id}`;
		return this.http.get(url);
	}

	validateEmailLinks(action, emailTemplateId) {
		const url = `${this.ALL_WORKFLOWS_URL}/validate`;
		const body = { action, emailTemplateId };
		return this.http.post(url, body);
	}

	validateEmailName(email) {
		const url = `${this.ALL_WORKFLOWS_URL}/email_template/name`;
		return this.http.post(url, email);
	}

	saveNewTasksOrder(taskId, newNumber, type, overdueDays) {
		const url = `${this.JOB_WORKFLOW_URL}/dragAndDrop`;
		const body = {
			taskId,
			newNumber,
			type,
			overdueDays
		};

		return this.http.post(url, body);
	}

	getWorkflowsOnPage({ perPage, page, pageOrder: { predicate, reverse } }) {
		const url = this.ALL_WORKFLOWS_URL;
		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);

		return this.http.get(url, { params });
	}

	deleteWorkflow(id) {
		const url = `${this.ALL_WORKFLOWS_URL}/delete?id=${id}`;
		return this.http.post(url, null);
	}

	getWorkflowNamesFromServer() {
		const url = '/protected/rest/job/source';
		return this.http.get(url);
	}

	private isDefaultWorkflowInList(workflows) {
		return workflows.some(
			workflow => workflow.name === this.defaultWorkflow.name
		);
	}

	private setWorkflowNamesInStorage(data): void {
		this.workflowNames = JSON.parse(JSON.stringify(data));
		if (!this.isDefaultWorkflowInList(this.workflowNames)) {
			this.workflowNames.push(this.defaultWorkflow);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/workflow/workflow.data.service.ts